export const DEFAULT_HEADER = {
  header: {
    "Content-Type": "application/json;charset=UTF-8",
  },
};

export const API_HOST = process.env.REACT_APP_API_HOST;
export const API_URL = {
  LOGIN: `/account/login`,
  LOGIN_CHECK: `/account/check`,
  ACCOUNT_INFO: `/account/my/info`,
  ACCOUNT_JOIN: `/account/join`,
  ACCOUNT_ID_CHECK: `/account/id/check`,
  ACCOUNT_HOSTING: "/account/hosting",
  KAKAO_AUTHORIZATION: `/kakao/auth/authorization`,
  ACCOUNT_AGENT_REGISTRATION: '/account/agent',
  ACCOUNT_CONNECT_REGISTRATION: '/account/connect',
  ACCOUNT_CREDIT: '/account/credit',
  ACCOUNT_KAKAO_AUTHORIZE: '/account/authorize/kakao',
  ACCOUNT_AUTO_CHARGE_CREDIT: '/account/credit/auto-charge',
  ACCOUNT_RESERVED_CREDIT: '/account/credit/reserved',
  ACCOUNT_CHANNEL: '/account/channel',
  /*
    회원가입 신청(`/wizard`) 전용 경로 — `channel_install_request` 에 담는다(2026-09-10).

    🔑 `ACCOUNT_CHANNEL`·`ACCOUNT_CONNECT_REGISTRATION` 과 **다른 경로인 이유**:
       그 둘에는 다른 화면이 물려 있다(`/channel/registration` '채널 추가',
       `/settings/connect` 커넥트 설정 폼). 그 화면들은 **채널이 이미 있는** 흐름이라
       `account_channel` 을 만드는 것이 맞고, 회원가입 신청만 성격이 다르다.
  */
  ACCOUNT_INSTALL_REQUEST_CHANNEL: '/account/install-request/channel',
  ACCOUNT_INSTALL_REQUEST_SUBMIT: '/account/install-request/submit',
  // 설치비 선결제 흐름(2026-10-12): 자기 신청 조회 / 견적 / (4) 비치 방법 저장 / (6) 결제 실행.
  ACCOUNT_INSTALL_REQUEST: '/account/install-request',
  ACCOUNT_INSTALL_REQUEST_QUOTE: '/account/install-request/quote',
  ACCOUNT_INSTALL_REQUEST_PLACEMENT: '/account/install-request/placement',
  ACCOUNT_INSTALL_REQUEST_PAY: '/account/install-request/pay',
  ACCOUNT_REDUCE_CREDIT: '/account/credit/reduce',
  ACCOUNT_COUNSEL: '/account/counsel',
  ACCOUNT_TERMINATION: '/account/termination',
  ACCOUNT_FIND_ID: '/account/find/id',
  ACCOUNT_FIND_ID_RES: '/account/find/id/res',
  ACCOUNT_FIND_PWD: '/account/find/password',
  ACCOUNT_FIND_PWD_RES: '/account/find/password/res',
  ACCOUNT_CHANGE_PWD: '/account/change/password',
  ACCOUNT_TIER: '/account/tier',
  ACCOUNT_SERVICE_EXPIRED: '/account/service/expired',
  SIMPLE_SCREEN_REGISTRATION: "/account/screen",
  SETTINGS: "/account/settings",
  REJECT: "/account/reject",
  ACCEPT: "/account/accept",

  ACCOUNT: `/account`,
  KAKAO_PROFILE_CHANNEL_AUTH: `/kakao/profile/authentication`,
  CHANNEL_AUTHORIZATION: `/kakao/profile/authorization`,
  CHANNEL_DUPLICATE: `/channel/duplicate`,
  CHANNEL_PUBLIC_Id: `/channel/public-id`,
  CHANNEL_PROFILE: '/channel/profile',

  REGION_TREE: `/region/tree`,
  REGION_SHIPPING_TREE: `/region/shipping`,

  GET_SPOTS: `/spot`,
  GET_ALL_SPOTS: `/spot/all`,

  // 진입점 그룹(해시태그) — 2026-08-27
  SPOT_TAGS: `/spot/tag`,
  SPOT_TAGS_BY_SPOT: `/spot/tag/by-spot`,
  SPOT_TAG_SPOTS: `/spot/tag/spots`,
  SPOT_TAG_ATTACH: `/spot/tag/attach`,
  SPOT_TAG_DETACH: `/spot/tag/detach`,
  SPOT_TAG_RENAME: `/spot/tag/rename`,
  GET_POOL_SPOTS: `/spot/pool-list`,
  POOL_OPTION_BENEFITS: `/pool-options/benefits`,
  POOL_OPTION_PROJECTS: `/pool-options/projects`,
  GET_ALL_PASSWORD_SPOTS: `/spot/all/password`,
  GET_SPOTS_STATISTICS: `/spot/statistics`,
  CREATE_SPOT: `/spot`,
  GET_SPOT: `/spot/{spotId}`,
  UPDATE_SPOT: `/spot`,
  CREATE_SPOT_FOLDER: `/spot-folders`,
  UPDATE_SPOT_FOLDER: `/spot-folders/{id}`,
  DELETE_SPOT_FOLDER: `/spot-folders/{id}`,
  UPDATE_SPOTS_FOLDER_BATCH: `/spot-folders/batch`,
  UPDATE_SPOTS_BENEFIT_BATCH: `/spot/batch/benefit`,
  DUPLICATE_SPOT_CHECK: `/spot/duplicate`,
  DUPLICATE_SPOT_FOLDER_CHECK: `/spot/folder/duplicate`,
  UPDATE_ENTRYPOINT_PASSWORD: `/spot/password`,
  UPDATE_QRCODE: `/spot/qrcode`,

  DELETE_SPOT: `/spot/{id}`,

  GET_FOLDERS: `/spot-folders`,
  CREATE_FOLDER: `/spot-folders`,

  GET_COUPONS: `/event/`,
  GET_COUPON: `/event/{id}`,
  CREATE_COUPON: "/event",
  UPDATE_COUPON: "/event/{id}",
  DELETE_COUPON: "/event/delete",

  GET_BENEFITS: `/benefit`,
  GET_BENEFIT_LEGACY: `/benefit/{id}`,
  GET_BENEFIT: `/benefits/{id}`,
  LIST_BENEFIT: '/benefits',
  POST_BENEFIT: '/benefits',
  COPY_BENEFIT: `/benefit/{id}/copy`,
  DELETE_BENEFIT: `/benefits/{id}`,
  LIST_KAKAO_GIFT: 'benefits/kakao/gift',
  DELETE_BENEFITS: `/benefit/delete`,
  CREATE_BENEFIT: `/benefit`,
  UPDATE_BENEFIT: `/benefit/{id}`,
  DUPLICATE_BENEFIT_CHECK: `/benefit/duplicate`,

  GET_COUPONS_STATISTICS: `/event/{spotId}/statistics`,

  PARTNER_BENEFIT_STATSTICS: `/benefit/statistics`,
  SPOT_BENEFIT_STATSTICS: `/benefit/spot/{spotId}/statistics`,

  PARTNER_USER_LIST: `/kakao/user/search`,
  PARTNER_USER_WORKBOOK: `/kakao/user/workbook`,
  USER_LIST_ALL: '/kakao/user/search/all',
  USER_DETAIL: '/kakao/user/detail',
  USER_PREFERENCE: '/kakao/user/preference',

  SAVE_MESSAGE_CONTENT: "/api/v1/campaign/insert",
  SCENARIO_SAVE: "/",

  FILE_UPLOAD: `/file`,
  FILE_KAKAO_UPLOAD: `/file/kakao/upload`,
  MESSAGE_FILE_UPLOAD: `/api/v1/kakao-bizmessage/image`,

  TARGET_CUSTOMERS: `/volatility-message/target-customers`,
  EXPECTED_CUSTOMER_COUNT: `/volatility-message/expected-customers/count`,
  GET_VOLATILITY_MESSAGES: `/volatility-message`,
  SENT_ONETIME_MESSAGES: `/volatility-message/sent-list`,
  MOMENT_AVAILABLE: `/volatility-message/moment-available`,
  MESSAGE_PRICES: `/volatility-message/message-prices`,
  DELETE_VOLATILITY_MESSAGE: `/volatility-message/{id}`,
  GET_VOLATILITY_MESSAGE: `/volatility-message/{id}`,
  GET_VOLATILITY_CLICK_USERS: `/volatility-message/{id}/click-users`,
  VOLATILITY_MESSAGE_RESERVED_CANCEL: `/volatility-message/{id}/cancel`,
  VOLATILITY_MESSAGE_SUMMARY: `/volatility-message/summary`,
  VOLATILITY_MESSAGE_COPY: `/volatility-message/{id}/copy`,
  TEST_VOLATILITY_MESSAGE: '/volatility-message/test',
  TEST_PHONE_VOLATILITY_MESSAGE: '/volatility-message/test/phone',
  SAVE_NOTIFICATION: `/volatility-message`,
  // 발송(예약) 등록 **전에** 쿠폰 코드 잔량을 확인한다. 저장하지 않는 읽기 전용 점검.
  COUPON_CODE_CHECK: `/volatility-message/coupon-code/check`,
  UPDATE_NOTIFICATION: `/volatility-message/{id}`,
  AI_CHAT: `/volatility-message/{id}/chat`,
  AI_RECOMMENDED_USERS: `/volatility-message/{id}/ai/recommended/users`,
  USE_BRAND_MSG: `/volatility-message/use-brand-msg`,

  GET_BILL: `/cash/bill`,
  GET_TAX_INVOICE: `/cash/tax-invoice`,
  GET_INVOICE: `/cash/invoice`, // A2 Phase G: 확정 고지서(cutoff 이상 월). 응답 mode 로 legacy/신 화면 분기
  GET_INVOICE_MONTHS: `/cash/invoice/months`, // 고를 수 있는 이용월 목록(2026-10-15). 풀다운은 이 목록으로만 채운다
  CARD_EXISTS: `/payment/card`,
  CARD_INFO_LIST: `/payment/card/info/list`,
  CARD_INFO: `/payment/card/info`,
  PAYMENT_BILL: `/payment/card/registration`,
  PAYMENT_PAY: `/payment/pay`,
  PAYMENT_REFUND: `/payment/refund`,
  CHANGE_CARD_DEFAULT: `/payment/card/change/default`,
  CARD_DELETE: `/payment/card/delete`,

  VOLATILITY_MESSAGE_COUPON: `/volatility-message/coupon`,

  MESSAGES: `/messages`,
  MESSAGES_CAMPAIGN: `/messages/campaign/{id}`,
  MESSAGE_CALENDAR: `/message-calendar`,
  MESSAGE_CALENDAR_SPECIAL_DATE: `/message-calendar/special-date`,
  MESSAGE_CALENDAR_MONTHLY_ALL: `/message-calendar/monthly-message/all`,
  MESSAGE_CALENDAR_MONTHLY_INCLUDE: `/message-calendar/monthly-message/include`,

  AUTOMATE_MESSAGE: '/automate-message/edit',
  AUTOMATE_MESSAGE_LIST: '/automate-message',
  AUTOMATE_MESSAGE_USED: '/automate-message/used',
  AUTOMATE_AI_GENERATE: '/automate-message/ai/generate',
  AUTOMATE_AI_GENERATE_IMAGE: '/automate-message/ai/generate/image',
  // 설문조사 자동화(CUSTOMER_POLL) 버튼 링크 후보 — 진입점 + 짧은링크 + 연결된 진행중 프로젝트·설문 여부 (2026-10-06)
  AUTOMATE_POLL_ENTRYPOINTS: '/automate-message/poll/entrypoints',
  // 설문조사 자동화 추가 — 관리자 전용(2026-10-12). 이미 있으면 새로 만들지 않는다.
  SYSADMIN_CREATE_CUSTOMER_POLL: '/sysadmin/automate-message/customer-poll',
  PROJECT_LiST: '/project',
  GET_PROJECT: '/project/{id}',
  DETAIL_PROJECT: '/project/{id}/detail',
  DETAIL_EVENTS_PROJECT: '/project/{id}/detail/events',
  ENTRY_POINTS_PROJECT: '/project/{id}/entryPoints',
  DETAIL_BENEFIT_QUANTITY_PROJECT: '/project/{id}/detail/benefit/quantity',
  DETAIL_BENEFIT_STATISTICS_PROJECT: '/project/{id}/detail/benefit/statistics',
  DETAIL_UN_USED_BENEFIT_QUANTITY_PROJECT: '/project/{id}/detail/benefit/quantity/unused',
  DETAIL_DUPLICATES_PROJECT: '/project/{id}/detail/duplicates',
  PRIZE_USERS_PROJECT: '/project/{id}/prize/users',
  POST_PROJECT: '/project',
  SAVE_NAME_PROJECT: '/project/{id}/name',
  SAVE_DUPLICATE_PROJECT: '/project/{id}/duplicate',
  TURN_PROJECT: '/project/turn',
  EVENT_PROJECT: '/project/event',
  PASSWORD_PROJECT: '/project/password',
  PERIOD_PROJECT: '/project/period',
  DUPLICATES_PROJECT: '/project/duplicates',
  DUPLICATE_DELETE_PROJECT: '/project/duplicate/delete',
  ENTRYPOINT_PROJECT: '/project/entryPoint',
  // 진입점별 점유 현황(진행중·예약 프로젝트가 쓰고 있는지) — 선택 화면 배지용
  ENTRYPOINT_OCCUPANCY: '/project/entryPoint/occupancy',
  EVENT_DELETE_PROJECT: '/project/event/delete',
  ENTRYPOINT_DELETE_PROJECT: '/project/entryPoint/delete',
  GET_REVISIT_EVENT_PROJECT: '/project/{id}/revisit',
  SAVE_REVISIT_EVENT_PROJECT: '/project/revisit',
  GET_META_TAG_PROJECT: '/project/{id}/meta-tag',
  GET_COMPLETE_REDIRECT_PROJECT: '/project/{id}/complete-redirect',
  COMPLETE_REDIRECT_PROJECT: '/project/complete-redirect',
  GET_SURVEY_PROJECT: '/project/{id}/survey',
  META_TAG_PROJECT: '/project/meta-tag',
  CHECK_NEW_USER_PROJECT: '/project/check-new-user',
  SURVEY_USED_PROJECT: '/project/survey/used',
  SURVEY_QUESTIONS_PROJECT: '/project/survey/questions',
  EVENT_LIST: '/event/list',
  POST_EVENT: '/event/save',
  DELETE_EVENT: '/event/{id}',
  GET_EVENT: '/event/get/{id}',
  PROJECT_KAKAO_USERS: '/statistics/project/users',
  STATISTICS_SPOT: '/statistics/spot',
  STATISTICS_ENTRYPOINT_BENEFIT: '/statistics/entry-point/benefit',
  STATISTICS_ORDERS: '/statistics/orders',
  CUSTOMERS: '/statistics/customers',
  STATISTICS_ORDERS_MESSAGE: '/statistics/orders/message',
  PRODUCT_LIST: '/product',
  PRODUCT_DETAIL: '/product/detail',
  PRODUCT_DELETE: '/product/{id}/delete',
  PRODUCT_REGISTRATION: '/product/generation',
  AI_MESSAGE_LIST: '/ai/volatility/messages',
  AI_MESSAGE: '/ai/volatility/message',
  AI_MESSAGE_EDIT: '/ai/volatility/message/{id}',
  AI_MESSAGE_DETAIL: '/ai/volatility/message/detail/{id}',
  AI_MESSAGE_VARIANTS: '/ai/volatility/message/variants/{id}',
  AI_MESSAGE_VARIANTS_STATUS: '/ai/volatility/message/variants/{id}/status',
  AI_CHAT_DETAIL: '/ai/volatility/chat/{id}',
  AI_UPDATE_PRODUCTS: '/ai/volatility/{id}/products',
  AI_ADD_PRODUCT: '/ai/volatility/{id}/add-product',
  IMAGE_UPDATE: '/ai/volatility/{id}/image',
  AI_STREAM_GENERATION: '/ai/volatility/stream-chat/{id}',
  AI_CREATE_GENERATION: '/ai/volatility/chat/{id}/create',
  AI_STREAM_INIT_GENERATION: '/ai/volatility/stream-chat/{id}/init',
  AI_GENERATION: '/ai/volatility/generate',
  AI_SEND: '/ai/volatility/send',

  COUNT_ALL_FRIEND: '/kakao/moment/ad/group/target',
  COUNT_EXPECTED_FRIEND: '/kakao/moment/ad/group/target/expected',
  BRAND: '/brand',

  LIST_POINT_MENU: '/point-menu/list',
  GET_POINT_MENU: '/point-menu/{id}',
  SAVE_POINT_MENU: '/point-menu',
  VISIBLE_POINT_MENU: '/point-menu/visible',
  BILLING_HISTORY: '/billing',
  GET_BILLING_HISTORY: '/billing/{id}',
  TOSS_BILLING: '/payments/toss/billing',

  TUTORIAL_PRODUCT_GENERATION: "/tutorial/product/generation",
  TUTORIAL_MESSAGE_GENERATION: "/tutorial/message/generation",
  TUTORIAL_PRODUCT_INFO: "/tutorial/product/info/{id}",

  VERIFICATION_DETAIL: "/verification/{id}",
  VERIFICATION_LIST: "/verification/list",
  VERIFICATION_STREAM: "/verification/stream",
  SIMPLE_SCREEN: "/simple-screen/login",
  ASSISTANT_AI: "/ai/assistant",
  LIST_ASSISTANT_AI: "/ai/assistant/list",
  ASSISTANT_AI_CHAT: "/ai/assistant/chat",
  BUSINESS_AI: "/ai/consulting/business",

  AI_BENEFIT_IMAGE_GENERATION: "/ai/image/benefit",

  AI_PROJECT_GENERATE: "/ai/generate/project",
  AI_EVENT_GENERATE: "/ai/generate/event",
  AI_STICKER_GENERATE: "/ai/generate/sticker",

  SYSTEM_BILLING: `/sysadmin/billing`,
  SYSTEM_PAY: `/sysadmin/pay`,
  SYSTEM_LOGO: `/sysadmin/logo`,
  SYSTEM_STICKER: `/sticker`, // 고객용(스티커 제작 화면). 관리자 접두어 밖으로 분리 — 2026-09-07
  SYSTEM_STAT: `/sysadmin/stat`,
  SYSTEM_CLAIM: `/sysadmin/claim`, // ⚠️ 사용처 0건 · 백엔드 엔드포인트 없음(죽은 상수)
  SYSTEM_ENTRYPOINT: `/sticker/entrypoint/list`, // 고객용. 관리자 접두어 밖으로 분리 — 2026-09-07
  // 배포된 백엔드의 커밋·빌드시각(2026-09-16). `/health` 가 아니라 여기 둔 이유는
  // 커밋 해시를 인증 없이 노출하지 않기 위해서다 — `SystemStatusController` KDoc 참고.
  SYSTEM_STATUS: `/sysadmin/status`,
  SYSTEM_INCIDENTS: `/sysadmin/incidents`, // 운영 사고(incident_log) 목록·요약·처리 — 2026-10-30
  SYSTEM_KAKAO_GIFT: `/sysadmin/kakao-gift`, // 카카오 선물 실패 조회·재발송 — 2026-10-30

  SETTLEMENT_GENERATE: `/sysadmin/settlement/generate`,
  SETTLEMENT: `/sysadmin/settlement`,
  SETTLEMENT_LIST: `/sysadmin/settlement/list`,
  SETTLEMENT_CHANNEL: `/sysadmin/settlement/channel`, // A2 Phase E: 채널 1개의 월별 정산 이력
  SETTLEMENT_GOLDEN: `/sysadmin/settlement/golden`,   // A2 ①: legacy vs 신 정산 대조(읽기 전용)
  SETTLEMENT_GENERATE_MISSING: `/sysadmin/settlement/generate-missing`, // 미생성분 일괄 초안 생성
  SETTLEMENT_REGENERATE_ALL: `/sysadmin/settlement/regenerate-all`,     // 전체 초안 재생성(확정분 제외)
  SETTLEMENT_PAY_CARD: `/sysadmin/settlement/{id}/pay-card`,      // ⚠️ 실제 카드 승인
  SETTLEMENT_MARK_DEPOSIT: `/sysadmin/settlement/{id}/mark-deposit`,
  SETTLEMENT_UNMARK_PAID: `/sysadmin/settlement/{id}/unmark-paid`,
  SETTLEMENT_ITEMS: `/sysadmin/settlement/{id}/items`,
  SETTLEMENT_REMARK: `/sysadmin/settlement/{id}/remark`,
  SETTLEMENT_CONFIRM: `/sysadmin/settlement/{id}/confirm`,
  SETTLEMENT_REOPEN: `/sysadmin/settlement/{id}/reopen`,
  SETTLEMENT_TAX: `/sysadmin/settlement/tax-invoice`,

  CATALOG: `/sysadmin/catalog`,
  CATALOG_ID: `/sysadmin/catalog/{id}`,
  SUBSCRIPTION: `/sysadmin/subscription`,
  SUBSCRIPTION_ID: `/sysadmin/subscription/{id}`,
  SUBSCRIPTION_END: `/sysadmin/subscription/{id}/end`,

  ONE_TIME_FEE: `/sysadmin/one-time-fee`,
  ONE_TIME_FEE_ID: `/sysadmin/one-time-fee/{id}`,
  ONE_TIME_FEE_CANCEL: `/sysadmin/one-time-fee/{id}/cancel`,
  // 그 달 1회성 비용이 걸린 채널 id 목록 — 정산관리 목록이 '구독 없는 채널'을 놓치지 않도록 (2026-08-31)
  ONE_TIME_FEE_CHANNELS: `/sysadmin/one-time-fee/channels`,
  // 그 달 1회성 비용 내역(전 채널, 취소 제외) — 전체 고객 화면의 기준월 표시 (2026-10-01)
  ONE_TIME_FEE_MONTH: `/sysadmin/one-time-fee/month`,
  // 결제 예정 안내 LMS (2026-10-02). preview = 대상·문구 미리보기(고지서 링크가 없으면 만든다), send = 1건 발송
  BILLING_NOTICE_DEFAULTS: `/sysadmin/billing-notice/defaults`,
  BILLING_NOTICE_PREVIEW: `/sysadmin/billing-notice/preview`,
  BILLING_NOTICE_SEND: `/sysadmin/billing-notice/send`,

  FLAG: `/sysadmin/flag`,
  FLAG_CODES: `/sysadmin/flag/codes`,
  FLAG_CHANNELS: `/sysadmin/flag/channels`,
  // 플래그 색상 + 런타임 설정(system_config) — 설정 화면 /sysadmin/setting (2026-08-06)
  FLAG_STYLES: `/sysadmin/flag/styles`,
  SYSTEM_CONFIG: `/sysadmin/config`,

  REVENUE_BREAKDOWN: `/sysadmin/revenue/breakdown`,
  REVENUE_CURRENT: `/sysadmin/revenue/current`,
  REVENUE_PROJECTION: `/sysadmin/revenue/projection`,
  REVENUE_STATUS: `/sysadmin/revenue/status`,
  REVENUE_REFRESH: `/sysadmin/revenue/refresh`,

  SYSTEM_CUSTOMERS: `/sysadmin/customers`,
  SYSTEM_CUSTOMER_CARDS: `/sysadmin/customers/{channelId}/cards`,
  // 기본 결제 카드 변경(2026-09-10). `[PAYMENT_RISK]` 다음 정산부터 이 카드로 청구된다.
  SYSTEM_CUSTOMER_CARD_DEFAULT: `/sysadmin/customers/{channelId}/cards/default`,
  // 과금 시작(2026-10-19). GET = 미리보기, POST = 시작일 고정 + 안내 LMS. `[MESSAGE_SEND_RISK]` POST 는 실제 고객에게 문자가 간다.
  SYSTEM_CUSTOMER_BILLING_START: `/sysadmin/customers/{channelId}/billing-start`,
  SYSTEM_CUSTOMER_BILLING_START_RESEND: `/sysadmin/customers/{channelId}/billing-start/resend-notice`,
  // 카드 등록 링크 LMS 발송(2026-10-19). `[MESSAGE_SEND_RISK]` send 는 실제 고객에게 문자를 보낸다.
  SYSTEM_CUSTOMER_CARD_LINK_MESSAGES: `/sysadmin/customers/{channelId}/card-link/messages`,
  SYSTEM_CUSTOMER_CARD_LINK_SEND: `/sysadmin/customers/{channelId}/card-link/send`,
  // 고객사 이력(타임라인, 2026-10-19) — channel_history 최신순. 읽기 전용
  SYSTEM_CUSTOMER_HISTORY: `/sysadmin/customers/{channelId}/history`,
  // 이력의 메시지 행 → 실제 보낸 내용(본문·버튼·결과, 2026-10-20). 읽기 전용
  SYSTEM_CUSTOMER_HISTORY_MESSAGE: `/sysadmin/customers/{channelId}/history/{historyId}/message`,
  SYSTEM_CUSTOMER_USED: `/sysadmin/customers/used`, // A2: 채널 서비스 활성/비활성 토글
  // 적립(Point) 서비스 개통·해지 — 고객사 상세 '적립 서비스' 구역 (2026-09-23, PERM-06)
  SYSTEM_SERVICE_PERMISSION_POINT: `/sysadmin/service-permission/point`,

  MESSAGE_STATISTICS: '/statistics/messages',

  LIST_POINT: '/point/list',
  SAVE_POINT: '/point/save',
  USE_POINT: '/point/use',
  ADD_POINT_USER: '/point/add-user',
  POINT_CONFIG: '/point/config',
  POINT_ENTRY_POINT_LIST: '/point/entry-point/list',
  MIN_POINT_CONFIG: '/point/config/min-point',
  GET_USER_POINT: '/point/user',
  GET_USER_POINT_HISTORY: '/point/user/history',
  POINT_CUSTOMER_REQUEST: '/point/customer/request',

  SURVEY_STATISTICS: '/project/{id}/survey/statistics',
  SURVEY_RESPONSES: '/project/{id}/survey/responses', // 응답자별 응답 시트(2026-09-28)

  ADVANCED_COUPON_USER: '/advanced/coupon/user',
  ADVANCED_COUPON_READY: '/advanced/coupon/payment/ready',
  ADVANCED_COUPON_REFUND: '/advanced/coupon/payment/refund',
  ADVANCED_COUPON_INFO: '/advanced/coupon/info',
  ADVANCED_COUPONS: '/advanced/coupon/coupons',
  ADVANCED_COUPON_USED: '/advanced/coupon/used',

  DASHBOARD_MAIN: '/dashboard',

  HOSTING_GENERATE: '/hosting/generate',
  HOSTING_INFO: '/hosting/info',
  WIZARD_ACCOUNT_LIST: '/sysadmin/wizard/account/list',
  WIZARD_PROFILE_LIST: '/sysadmin/wizard/profile/list',
  WIZARD_PROFILE_INFO: '/sysadmin/wizard/profile/info',
  WIZARD_CHANNEL_SAVE: '/sysadmin/wizard/channel',
  WIZARD_CHANNEL_PENDING: '/sysadmin/wizard/channel/pending',
  WIZARD_CHANNEL_SETUP: '/sysadmin/wizard/channel/setup',
  WIZARD_CHANNEL_COMPLETED: '/sysadmin/wizard/channel/completed',
  // STEP 4 직후 채널의 연동 방식(hosting_name) 조회 — STEP 5 '홈페이지 생성' 을 보여줄지 판정(2026-10-30).
  WIZARD_CHANNEL_INFO: '/sysadmin/wizard/channel/info',

  // 초기 세팅 위저드(/sysadmin/wizard/init-setting) — '설치 진행자' 용. 2026-09-07 신규.
  // 위 WIZARD_* 는 '백엔드 연동 작업자' 화면(/sysadmin/wizard/backend)의 것이다. 담당자가 다르다.
  // ⚠️ 2026-09-08 에 `install` → `init-setting` 으로 바꿨다(온보딩 용어 통일).
  //    백엔드는 전환기 동안 두 경로를 모두 받는다 — 배포 순서를 무관하게 하기 위한 것이고,
  //    프론트 배포가 끝나면 백엔드에서 구 경로를 제거한다.
  INIT_SETTING_ACCOUNTS: '/sysadmin/wizard/init-setting/accounts',
  INIT_SETTING_DETAIL: '/sysadmin/wizard/init-setting',
  INIT_SETTING_SAVE: '/sysadmin/wizard/init-setting',
  INIT_SETTING_CARD_REQUEST: '/sysadmin/wizard/init-setting/card-request',
  INIT_SETTING_QUEUE: '/sysadmin/wizard/init-setting/queue',
  INIT_SETTING_CARD_LINK: '/sysadmin/wizard/init-setting/card-link',

  // 사업자번호 확인 고유링크 — 🔴 로그인 없이 열리는 경로다(SecurityConfig permitAll).
  // 여기에 조회·삭제 API 를 추가하지 말 것. 도달 가능한 행위는 '카드 1장 추가' 하나여야 한다.
  CARD_LINK_INFO: '/card-link/info',
  CARD_LINK_VERIFY: '/card-link/verify',
  TOSS_BILLING_LINK: '/payments/toss/billing/link',

  // 고지서 열람 링크(2026-10-02, 결제 예정 안내 LMS) — 🔴 로그인 없이 열리는 경로다(SecurityConfig permitAll).
  // 도달 가능한 행위는 '사업자번호를 맞힌 사람이 그 달 확정 고지서를 읽는 것' 하나여야 한다.
  INVOICE_LINK_INFO: '/invoice-link/info',
  INVOICE_LINK_VERIFY: '/invoice-link/verify',
};
